//Please add the language resource
const sign = {
  shipperName: 'shipperName',
  companyCode: 'shipperName',
  orderNo: 'orderNo',
  waybillNo: 'waybillNo',
  customerOrderNo: 'customerOrderNo',
  soOrSto: 'soOrSto',
  orderType: 'orderType',
  orderDate: 'orderDate',
  reqDispatchDate: 'reqDispatchDate',
  transTypeNo: 'transTypeNo',
  reqArriverDate: 'reqArriverDate',
  carrierNo: 'carrierNo',
  carrierName: 'carrierName',
  orderStatusNo: 'orderStatusNo',
  originAddrCode: 'originAddrCode',
  originAddrName: 'originAddrName',
  originAddrContactMan: 'originAddrContactMan',
  originAddrContactTel: 'originAddrContactTel',
  originAddrCityName: 'originAddrCityName',
  originAddrLocation: 'originAddrLocation',
  destAddrCode: 'destAddrCode',
  destAddrName: 'destAddrName',
  destAddrContactMan: 'destAddrContactMan',
  destAddrContactTel: 'destAddrContactTel',
  destAddrCityName: 'destAddrCityName',
  destAddrLocation: 'destAddrLocation',
  totalQty: 'totalQty',
  totalVolume: 'totalVolume',
  totalWeight: 'totalWeight',
  totalNetWeight: 'totalNetWeight',
  signStatusName: 'signStatusName',
  rejectReasonName: 'rejectReasonName',
  remark: 'remark',
  skuCode: 'skuCode',
  skuName: 'skuName',
  qty: 'qty',
  skuLotNo: 'skuLotNo',
  rejectQuantity: 'rejectQuantity',
  lineNo: 'lineNo',
  signTime: 'signTime',
  signStatus: 'signStatus',
  signBack: 'signBack',
  signBatch: 'signBatch',
  receiptBatch: 'receiptBatch',
  urgentFlag: 'urgentFlag',
  receiptConfirm: 'receiptConfirm',
  orderStatusName:'orderStatusName',
  companyName:'companyName',
  transTypeName:'transTypeName',
  signOperationTime:'signOperationTime',
};
export default sign



// WEBPACK FOOTER //
// ./src/page/sign/lang/sign.en.js